var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dialog-container" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            width: "450px",
            title: "Thêm khoản thu",
            visible: _vm.isOpenAddNameExpensesDialog,
            "before-close": _vm.handleCloseChangeNameRevenusDialog,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isOpenAddNameExpensesDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "formData",
                  attrs: {
                    model: _vm.formData,
                    "label-position": "left",
                    rules: _vm.rules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "Tên khoản thu mới", prop: "newNameKT" },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "Nhập tên khoản thu mới" },
                        model: {
                          value: _vm.formData.newNameKT,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "newNameKT", $$v)
                          },
                          expression: "formData.newNameKT",
                        },
                      }),
                      _c("span", { staticClass: "error-message" }, [
                        _vm._v(_vm._s(_vm.customErrorMessages.newNameKT)),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "custom_button" },
                [
                  _vm.showSaveChange
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "success",
                            size: "medium",
                            loading: _vm.loadingChangeName,
                          },
                          on: { click: _vm.submitForm },
                        },
                        [
                          _c("i", { staticClass: "el-icon-circle-check" }),
                          _vm._v(" Lưu\n        "),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "medium", type: "danger" },
                      on: { click: _vm.handleCloseChangeNameRevenusDialog },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-close" }),
                      _vm._v(" Đóng\n        "),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }